import { createContext, useState, useEffect } from "react";

export const CurrentUser = createContext()

function CurrentUserProvider({ children }){
    const location = window.location
    const tokenData = new URLSearchParams(location.search).get('tokenData');

    const [currentUser, setCurrentUser] = useState(null)
    const [isLoggedIn, setIsLoggedIn] = useState(false)

    useEffect(() => {
        const getIsLoggedIn = async () => {
            if (!tokenData) {
                let response = await fetch(`${process.env.REACT_APP_SERVER_URL}auth/isLoggedIn`, {
                    headers:{
                        'Authorization' : `Bearer ${localStorage.getItem('token')}`
                    }
                });
                let { isLoggedIn } = await response.json();
                setIsLoggedIn(isLoggedIn)
            }
        };
        getIsLoggedIn()
    }, []);

    useEffect(() => {
        const getLogInWithTokenData = async () => {
            if (!isLoggedIn && tokenData) {
                let response = await fetch(`${process.env.REACT_APP_SERVER_URL}auth/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ tokenData })
                });
                const data = await response.json();
       
                if (response.status === 200) {
                    setIsLoggedIn(true);
                    localStorage.setItem('token', data.token);
                } else {
                    setIsLoggedIn(false);
                }
                location.replace('/')
                
            }
        }
        getLogInWithTokenData()
    }, [])

    return (
        <CurrentUser.Provider value={{ currentUser, setCurrentUser, isLoggedIn }}>
            {children}
        </CurrentUser.Provider>
    )
}

export default CurrentUserProvider